import PriceQueryForm from './PriceQueryForm';

export default PriceQueryForm;
